import React from 'react';
import Constants from 'js/Constants';

export type FileItemListRow = {
  lastIngested?: string;
  updated_at?: string;
  lastWritten?: string;
  recordCount: number;
  errorCount: number;
  ingestionStatus?: string;
  writeStatus?: string;
  metadata: {
    display_path: any;
    date: any;
    from_email: boolean | React.ReactChild | React.ReactFragment | React.ReactPortal;
    subject: boolean | React.ReactChild | React.ReactFragment | React.ReactPortal;
  };
  name: any;
  onClickPreview: (arg0: any) => any;
  size: any;
};

const { IngestionStatus } = Constants;

export const IngestionStatusInfo = {
  [IngestionStatus.COMPLETE]: {
    title: 'Completed',
    color: 'success',
  },
  [IngestionStatus.ERROR]: {
    title: 'Error',
    color: 'danger',
  },
  [IngestionStatus.IN_PROGRESS]: {
    title: 'In Progress',
    color: 'primary',
  },
  [IngestionStatus.STARTED]: {
    title: 'Started',
    color: 'primary',
  },
  [IngestionStatus.DOWNLOADING]: {
    title: 'Downloading',
    color: 'primary',
  },
  [IngestionStatus.PARSING]: {
    title: 'Parsing',
    color: 'primary',
  },
  [IngestionStatus.POST_PROCESSING]: {
    title: 'Post Processing',
    color: 'primary',
  },
  [IngestionStatus.PARTIAL]: {
    title: 'Partial success',
    color: 'danger',
  },
  [IngestionStatus.NOT_STARTED]: {
    title: 'Not Started',
    color: 'primary',
  },
  [IngestionStatus.QUEUED_REINGEST]: {
    title: 'Queued',
    color: 'disabled',
  },
  [IngestionStatus.RECOVERED]: {
    title: 'Recovered',
    color: 'primary',
  },
};
